export enum Weekday {
  SUNDAY = 'Sunday',
  MONDAY = 'Monday',
  TUESDAY = 'Tuesday',
  WEDNESDAY = 'Wednesday',
  THURSDAY = 'Thursday',
  FRIDAY = 'Friday',
  SATURDAY = 'Saturday',
}

export enum WeekdayLowercase {
  SUNDAY = 'sunday',
  MONDAY = 'monday',
  TUESDAY = 'tuesday',
  WEDNESDAY = 'wednesday',
  THURSDAY = 'thursday',
  FRIDAY = 'friday',
  SATURDAY = 'saturday',
}

export const WEEKDAY_NAMES: string[] = [
  Weekday.SUNDAY,
  Weekday.MONDAY,
  Weekday.TUESDAY,
  Weekday.WEDNESDAY,
  Weekday.THURSDAY,
  Weekday.FRIDAY,
  Weekday.SATURDAY,
];

export const WEEKDAY_NAMES_LOWERCASE: string[] = [
  WeekdayLowercase.SUNDAY,
  WeekdayLowercase.MONDAY,
  WeekdayLowercase.TUESDAY,
  WeekdayLowercase.WEDNESDAY,
  WeekdayLowercase.THURSDAY,
  WeekdayLowercase.FRIDAY,
  WeekdayLowercase.SATURDAY,
];

export const WEEKDAY_NAMES_BY_INDEX: Record<number, string> = {
  0: Weekday.SUNDAY,
  1: Weekday.MONDAY,
  2: Weekday.TUESDAY,
  3: Weekday.WEDNESDAY,
  4: Weekday.THURSDAY,
  5: Weekday.FRIDAY,
  6: Weekday.SATURDAY,
};
